import React from 'react';
import './styles/global.css';

import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import VideoBand from './components/VideoBand/VideoBand';
import VideoShowcase from './components/VideoShowcase/VideoShowcase';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import FullVideo from './components/FullVideo/FullVideo';
import FarmingProcess from './components/FarmingProcess/FarmingProcess';
import Certification from './components/Certification/Certification';
import PhotoStories from './components/PhotoStories/PhotoStories';
import Collage from './components/Collage/Collage';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import WhatsAppButton from './components/ScrollToTop/WhatsAppButton';

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <VideoBand />
        <VideoShowcase />
        <WhyChooseUs />
        <FarmingProcess />
        <Certification />
        <PhotoStories />
        <Collage />
        <FullVideo />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppButton />
    </>
  );
}

export default App;
